/* --------------------------------------------------
Import modules
-------------------------------------------------- */
import Filters from '@meteora-digital/filters'; // Video watcher
// Find the case studies page element

var page = document.querySelector('.js-case-studies'); // Find the form element

var form = page.querySelector('.js-case-studies--form'); // Find the intersection element

var intersection = document.querySelector('.js-case-studies-intersection');
var ViewObserver = new IntersectionObserver(function (entries) {
  document.body.classList.toggle('flip-contrast', !entries[0].isIntersecting);
});
ViewObserver.observe(intersection);
console.log('Case studies page loaded', intersection); // Use this to throttle the filter

var timeouts = {};

if (form) {
  // Find the list element
  var list = page.querySelector('.js-case-studies--list'); // Create a new Filters instance

  var Filter = new Filters(page.getAttribute('data-api') || '/');
  Filter.on('success', function (response) {
    // Append the response to the content
    list.innerHTML = response;
    setTimeout(function () {
      // Load any new lazy images
      window.Lazy.update(); // Initialise the in view items

      window.inView.update();
    }, 100); // After everything is set up remove the loading class

    setTimeout(function () {
      list.classList.remove('loading');
    }, 300);
  }); // An update method to control the content filter

  var update = function update() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    clearTimeout(timeouts['update']);

    if (value === '') {
      Filter.remove('type', value);
    } else {
      // Set a new filter value
      Filter.set('type', value);
    } // Add a class to show we are loading content


    list.classList.add('loading');
    timeouts['update'] = setTimeout(function () {
      // Filter the content
      Filter.apply();
    }, 500);
  };

  form.addEventListener('change', function (e) {
    update(e.target.value);
  });
}

function watchForVideos() {
  window.removeEventListener('mousemove', watchForVideos);
  var videoMap = new Map();
  var ViewObserver = new IntersectionObserver(function (entries) {
    // Loop through the entries
    entries.forEach(function (entry) {
      // If this entry target is in the video map
      var _videoMap$get = videoMap.get(entry.target),
          media = _videoMap$get.media,
          video = _videoMap$get.video;

      if (!video) return; // If the entry is in view

      if (entry.isIntersecting) {
        // Append the video to the item
        media.appendChild(video);
      } else {
        if (!media.contains(video)) return; // If the entry is not in view, remove it from the item

        media.removeChild(video);
      }
    });
  });
  DomObserver.observe('.js-case-study', function (items) {
    // Empty the video map
    videoMap.clear();
    items.forEach(function (item) {
      var media = item.querySelector('.js-case-study--media');
      var videoTemplate = item.querySelector('.js-case-study--video');
      if (!videoTemplate) return; // Grab the first child of the video template

      var video = videoTemplate.content.firstElementChild; // If there is no video, return

      if (!video) return;
      videoMap.set(item, {
        video: video,
        media: media
      }); // Observe the item

      ViewObserver.observe(item);
    });
  });
}

window.addEventListener('mousemove', watchForVideos);